import { WifiOff, ScanLine, Camera } from 'lucide-react';
import { useReveal } from '@/lib/useReveal';
import { Section, Container, Display, Lead, CtaLink, Phone } from '@/components/system';

/**
 * Mi Admin — the field app, on black. Offline-first is the differentiator that
 * matters most in the Cuba corridor, so it gets its own band.
 */
const points = [
  { icon: WifiOff, title: 'Sin señal, sigue trabajando.', text: 'Escanea y entrega sin conexión; todo se sincroniza al reconectar.' },
  { icon: ScanLine, title: 'Cientos de artículos, un escaneo.', text: 'Actualización masiva en almacén al recibir o despachar.' },
  { icon: Camera, title: 'Foto, firma y GPS.', text: 'Cada entrega queda comprobada — visible para la agencia y para el cliente.' },
];

export function MiAdminShowcase() {
  const ref = useReveal<HTMLElement>();
  return (
    <Section tone="black" ref={ref} className="overflow-hidden">
      <Container>
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <p data-reveal className="flex items-center gap-3 text-text-muted font-semibold mb-5">
              <img src="/logos/apps/scanner.png" alt="" width={32} height={32} loading="lazy" className="w-8 h-8 rounded-lg" />
              Mi Admin
            </p>
            <Display data-reveal size="lg" className="text-white">
              Sin señal.
              <br />
              Sin problema.
            </Display>
            <Lead data-reveal dark className="mt-6 max-w-xl">
              La app de almacén y reparto está hecha para el corredor a Cuba: los apagones
              no avisan, y el trabajo no puede esperar.
            </Lead>
            <ul className="mt-10 space-y-7">
              {points.map((p) => (
                <li key={p.title} data-reveal className="flex gap-4">
                  <div className="mt-1 w-10 h-10 shrink-0 rounded-xl bg-white/10 flex items-center justify-center">
                    <p.icon className="w-5 h-5 text-brand-light" />
                  </div>
                  <div>
                    <p className="text-white text-lg font-semibold tracking-tight">{p.title}</p>
                    <p className="text-text-muted mt-1">{p.text}</p>
                  </div>
                </li>
              ))}
            </ul>
            <div data-reveal className="mt-10">
              <CtaLink to="/plataforma/mi-admin" dark>Conoce Mi Admin</CtaLink>
            </div>
          </div>
          <div className="relative flex justify-center lg:justify-end items-start gap-5 sm:gap-6">
            <div data-reveal className="hidden sm:block translate-y-12">
              <Phone src="/screens/mi-admin-home.png" alt="Mi Admin — inicio con el resumen del día del repartidor" width={240} />
            </div>
            <div data-reveal>
              <Phone src="/screens/mi-admin-lista.png" alt="Mi Admin — paquetes asignados del día, con su estado" width={270} />
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
}
